<notification-drawer
    [open]="open"
    [loading]="loading$ | async"
    [notifications]="notifications$ | async"
    (close)="handleClose()"
    (archive)="handleArchive($event.notification, $event.archive)"
    (markReadUnread)="handleMarkReadUnread($event.notification, $event.read)"
    (openNotification)="handleOpenNotification($event)"
    (markAllAsRead)="handleMarkAllAsRead()"
    (filterChange)="handleFilterChange($event)"
></notification-drawer>
